module.exports = new __parcel__URL__("cancel_btn_purple.8cd34028.png").toString();